import { ChangeDetectorRef, Component, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map, of, take } from 'rxjs';
import { Portfolio } from '../../../../models/portfolio';
import { PropertyAbstract } from '../../../../models/propertyAbstract';
import { AuthenticationService } from '../../../../services/AuthenticationService';
import { PortfolioService } from '../../../../services/PortfolioService';
import { PropertyService } from '../../../../services/PropertyService';
import { BiddingHistoryDialogComponent } from '../../../../shared/dialog/bidding-history-dialog.component';
import { SelectPortfolioDialogComponent } from '../../dialog/select-portfolio-dialog.component';
import { PropertyPhase } from '../../../../models/propertyPhase';

@Component({ standalone: false,
  selector: 'app-dashboard-property',
  templateUrl: './dashboard-property.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dashboard-property.component.scss'] 
})
export class DashboardPropertyComponent implements OnInit {
  readonly propertyAbstract = input.required<PropertyAbstract>();
  readonly highlighted = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly readonly = input<boolean>(false);
 
  readonly propertyClicked = output<{pa:PropertyAbstract, section:string}>();

  protected readonly Math = Math;

  public routerPath="/properties";

  constructor(private propertyService:PropertyService, private portfolioService:PortfolioService, private authService:AuthenticationService, private dialog: MatDialog, private cd:ChangeDetectorRef) {
    
  }

  ngOnInit() { }

  ngAfterViewInit(){ }

  public getSaleType(pa:PropertyAbstract){
    return pa.saleType ? this.propertyService.getSaleTypeById(pa.saleType) : of(undefined);
  }

  get isClient(){
    return this.authService.currentUserValue!.isClient;
  }

  /** phase changes only for users who may edit properties (client users: read-only) */
  get canEditProperties(){
    return !!this.authService.currentUserValue?.canEditProperties;
  }

  get isAuction(){
    return this.propertyAbstract().auctionType===1;
  }

  get isMakeOfferBuyNow(){
    return this.propertyAbstract().auctionType===2;
  }

  get isRegularSale(){
    return this.propertyAbstract().auctionType===3;
  }

  get isCallForOffer(){
    return this.propertyAbstract().auctionType===4;
  }

  get portfolioPropertyCount(){
    return this.portfolioService.getPortfolioById(this.propertyAbstract().portfolioId!,false).pipe(take(1), map((p:Portfolio|undefined)=>{
      return p?p.propertyAbstracts.length:0;
    }));
  }

  get propertyPhase(){
    return this.propertyAbstract().propertyPhase;
  }

  get propertyPhases(){
    return this.propertyService.propertyPhases;
  }

  public onSelectPropertyPhase(phase:PropertyPhase){
    this.propertyService.updatePropertyPhase(this.propertyAbstract().id, phase).pipe(take(1)).subscribe();
  }
 
  //#region show bidding history for admin
  public onBidsClick(pa:PropertyAbstract){
    if(!this.disabled()) this.propertyBidHistoryDialog(pa);
  }

  private propertyBidHistoryDialog(pa:PropertyAbstract){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data={pa:pa};
    dialogConfig.minWidth=800;
    this.dialog.open(BiddingHistoryDialogComponent, dialogConfig).afterClosed().pipe(take(1)).subscribe(value=>{
      if(value){
        //do nothing
      }
      else{
        //do nothing
      }
    });
  }
  //#endregion

  public onPortfolioClick($event:any){
    this.portfolioService.getPortfolioById(this.propertyAbstract().portfolioId!,false).pipe(take(1)).subscribe((p:Portfolio|undefined)=>{
      if(p){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth=800;
        dialogConfig.data={ portfolio:p, currentPropertyPortfolioId: p.id};
        this.dialog.open(SelectPortfolioDialogComponent,  dialogConfig).afterClosed().pipe(take(1)).subscribe(value=>{
          if(value && p.id!=value.id){
            this.portfolioService.storePortfolioProperty(p.id,value.id,this.propertyAbstract(),"N/A").pipe(take(1)).subscribe(r =>{
              if(r.success) this.cd.detectChanges();
            });
          }
        });
      }
    });
  }

  public onPropertyClick(){
    this.propertyClicked.emit({pa:this.propertyAbstract(), section:'all'});
  }
  public onLeftSectionClick(){
    this.propertyClicked.emit({pa:this.propertyAbstract(), section:'left'});
  }
  public onCenterSectionClick(){
    this.propertyClicked.emit({pa:this.propertyAbstract(), section:'center'});
  }
  public onRightSectionClick(){
    this.propertyClicked.emit({pa:this.propertyAbstract(), section:'right'});
  }
  public async onAddressCopyClick(){
    try {
      await navigator.clipboard.writeText(this.propertyAbstract().address.formattedAddress);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }
}
